import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { HeadingCell } from '../BuiltRow';

class HeadingCellController implements angular.IComponentController {
    cell: HeadingCell;
    isEditMode: boolean;
    
    static $inject = [];
}

export const wtHeadingCell: ComponentDefinition = {
    componentId: 'wtHeadingCell',
    controller: HeadingCellController,
    template: require('./headingCell.component.html'),
    controllerAs: 'vm',
    bindings: {
        cell: '<',
        isEditMode: '<'
    }
};
